import request from '@/utils/request'

let PackingApi = {
    /*获取数据*/
    copy(data, errorback) {
        return request._get('/shop/plus.packing.packing/copy', data, errorback);
    },
    /*获取数据库操作*/
    data(data, errorback) {
        return request._get('/shop/plus.packing.packing/data', data, errorback);
    },
    /*文件处理*/
    file(data, errorback) {
        return request._get('/shop/plus.packing.packing/file', data, errorback);
    },

}
export default PackingApi;



// WEBPACK FOOTER //
// ./src/api/packing.js